@if (!adding) {
  <div>
    <a href="#" (click)="onAdd($event)">
      <fa-icon [icon]="['fas', 'plus-square']" /> @if (!minimizeControls) {
      <span>Add Note</span>
    }
  </a>
</div>
}
@if (adding) {
  <div>
    <form (submit)="onSubmit()">
      <div>
        <textarea
          name="newNote"
          [formControl]="newNote"
          class="w-100"
          rows="3">
        </textarea>
      </div>
      <div class="text-end">
        <button class="btn btn-sm btn-secondary" (click)="onCancelAdd($event)">
          @if (minimizeControls) {
            <fa-icon [icon]="['fas', 'times']" />
          }
          @if (!minimizeControls) {
            <span>Cancel</span>
          }
        </button>
        <button class="btn btn-sm btn-primary">
          @if (minimizeControls) {
            <fa-icon [icon]="['fas', 'check']" />
          }
          @if (!minimizeControls) {
            <span>Save</span>
          }
        </button>
      </div>
    </form>
  </div>
}